

import templateOrderDetailPage from '@/app-template/lib/pages/OrderDetailPage.vue';

export default {
  name: "OrderDetailPage",
  components: { templateOrderDetailPage },
};
